// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperFinderUpsell-cls1_H2h","cls2":"PaperFinderUpsell-cls2_lF2 PaperFinderUpsell-cls1_H2h"};